<script setup lang="ts">
import { ref, computed } from 'vue'
import TitlebarMenuItemView from './TitlebarMenuItemView.vue'
import type MenuItem from '../../../type/MenuItem'
import { isNotMobileBrowser } from '@/utils/util'

const { menus, width } = defineProps({
  menus: {
    type: Array<MenuItem>,
    required: true
  },
  width: {
    type: Number,
    required: false,
    default: 100
  }
})

let popperRef = ref()

const emit = defineEmits(['onItemClicked'])

const triggerMode = computed(() => {
  return isNotMobileBrowser() ? 'hover' : 'click'
})

function handleClicked(item: MenuItem, index: number) {
  console.log(triggerMode)
  emit('onItemClicked', item, index)
  popperRef.value?.hide()
}
</script>
<template>
  <el-popover
    ref="popperRef"
    placement="bottom"
    :width="width"
    :trigger="triggerMode"
    popper-class="context-menu"
    :popper-style="{ 'z-index': 3026, padding: '8px 0px' }"
    :hide-after="50">
    <template #reference>
      <div class="reference-wrapper">
        <slot name="trigger"></slot>
      </div>
    </template>
    <TitlebarMenuItemView
      v-for="(item, index) in menus"
      :key="index"
      :menuItem="item"
      @click="handleClicked(item, index)">
    </TitlebarMenuItemView>
  </el-popover>
</template>
<style scoped>
.reference-wrapper {
  display: inline-block;
}
</style>
